import React, { Component } from 'react';
import SearchResults from './SearchResults';
import HeaderMin from '../headermin';
import FirebaseDB from '../firebase';

export class SearchForm extends Component {
    constructor(props) {
        super(props);

        const area = props.match.params.searcharea;
        const term = props.match.params.searchterm;

        console.log("constructor");

        if (area && term) {
            this.state = { area: area, term: term };
        }
        else
            this.state = { area: "CanonEquipment", term: "" };

        this.handleRadio = this.handleRadio.bind(this);
        this.handleTerm = this.handleTerm.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount() {
        if (this.props.match.params.searcharea && this.props.match.params.searchterm) {
            if (!this.state.logged) {
                this.logEvent(this.props.match.params.searcharea, this.props.match.params.searchterm);
                this.state.logged = true;
            }
            this.getSearchResults(this.props.match.params.searcharea, this.props.match.params.searchterm);
        }
    }

    logEvent(search_area, searchterm) {
        const db = new FirebaseDB("search");
        db.upload("searchHistory", { search: `${search_area + ":" + searchterm}` });
        db.doMetrics(`${search_area + ":" + searchterm}`);
        db.analyticsLogEvent("searchSubmitted", { area: `${search_area + ":" + searchterm}` });
    }

    getSearchResults(search_area, searchterm) {
        console.log(`get search results ${search_area} ${searchterm}`);
        let full_text_query = searchterm.trim().replace(/\s+|$/g, "*");
        let like_query = "%" + searchterm.trim() + "%";

        window.fetch(`http://www.signsandimpressions.com/search?searcharea=${search_area}&like=${like_query}&ft=${full_text_query}`)
            .then(response => response.json())
            .then(data => this.setState({ search_results: data }))
            .catch(() => { this.setState({ search_results: "failed" }) });
    }

    handleRadio(event) {
        console.log("handle radio");
        this.setState({ area: event.target.value });
    }

    handleTerm(event) {
        console.log("handle term");
        this.setState({ term: event.target.value });
    }

    handleSubmit(event) {
        event.preventDefault();
        console.log("handle submit");
        if (this.state.area && this.state.term !== "")
            window.location = `/search/${this.state.area}/${this.state.term}`;
        else
            this.setState({ submitted: false });
    }

    renderSearchForm() {
        let divErrorContents = "";
        if (this.state.submitted === false) {
            divErrorContents = "Cannot submit empty search. Please enter a new search";
        }
        return (
            <>
                <HeaderMin />
                <div className="container">
                    <div className="container mt-3">
                        <strong>Select search area from the radio buttons. </strong>
                    Then you can type something like "shredder", "color printer" or "scanner", for example.
                    </div>
                    <h3 id="search-header">Search bssantigua.com</h3>
                    <form id="search-site-form" onSubmit={this.handleSubmit}>
                        <div className="form-check form-check-inline">
                            <input className="form-check-input" type="radio" id="canon"
                                name="searcharea"
                                value="CanonEquipment"
                                checked={this.state.area === "CanonEquipment"}
                                onChange={this.handleRadio}
                            />
                            <label className="form-check-label" for="CanonEquipment">Canon Equipment</label><br />
                        </div>
                        <div className="form-check form-check-inline">
                            <input className="form-check-input" type="radio" id="OfficeEquipment"
                                name="searcharea"
                                value="OfficeEquipment"
                                checked={this.state.area === "OfficeEquipment"}
                                onChange={this.handleRadio}
                            />
                            <label className="form-check-label" for="OfficeEquipment">Office Equipment</label><br />
                        </div>
                        <div className="form-check form-check-inline">
                            <input className="form-check-input" type="radio" id="OfficeFurniture"
                                name="searcharea"
                                value="OfficeFurniture"
                                checked={this.state.area === "OfficeFurniture"}
                                onChange={this.handleRadio}
                            />
                            <label className="form-check-label" for="OfficeFurniture">Office Furniture</label><br />
                        </div>
                        <div className="d-flex">
                            <input type="text" value={this.state.term} onChange={this.handleTerm} class="form-control" placeholder="Customized Search" />
                            <input id="search-submit-btn" type="image" src="/images/submit-search.svg"></input>

                        </div>
                    </form>
                    <div>{divErrorContents}</div>
                </div>
            </>
        )
    }

    render() {
        console.log("render");
        console.log(this.state);
        return (
            <>
                {this.renderSearchForm()}
                {this.state.search_results &&
                    <>
                        <div className="container">
                            <h5><SearchAdvice searcharea={this.props.match.params.searcharea} searchterm={this.props.match.params.searchterm} count={this.state.search_results.length} /></h5>
                            <SearchResults searcharea={this.state.area} searchterm={this.state.term} results={this.state.search_results} />
                        </div>
                    </>
                }
            </>
        )
    }
}

const SearchAdvice = (props) => {
    let count = props.count;
    let terms = props.searchterm.trim();

    let result = count === 1 ? " result" : " results";

    return (
        <>
            {"Search for \"" + terms + "\" in " + props.searcharea + " returned " + count + result}<br />
            {count === 0 && "Please modify your search terms. Please note that a search should be minimum 4 characters."}
        </>
    )

}



